import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
  esp: (
    `
    <p class="mb-3">
      En certaj (tre malvarmaj) kondiĉoj eĉ glacio elradias varmon.
    </p>
    
    <p class="mb-3">
      Sed ĉu indas krei por tio konvenajn kondiĉojn?
    </p>
  `
  )
}

const itemName = {
  esp: 'La varmo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;